const { coreApi } = require('../utils/axios');

async function getCategories(params) {
  const query = new URLSearchParams(params).toString()
  const response = await coreApi.get(`/shop/categories?${query}`);
  return {
    categories: response.data.data,
    pagination: response.data.pagination,
  };
}

async function getCategoryGroups() {
  const response = await coreApi.get('/shop/category-groups');
  return response.data.data;
}

async function updateCategory(categoryId, updatePayload) {
  await coreApi.put(`/shop/categories/${categoryId}`, updatePayload);
}

async function syncCategories() {
  const response = await coreApi.put('/shop/categories');
  return {
    categories: response.data.data,
    pagination: response.data.pagination,
  };
}

async function getFeatureFlags() {
  const response = await coreApi.get('/feature-flags');
  return response.data.data;
}

async function getOrganisationFeatures(organisationId) {
  const response = await coreApi.get(`/v3/pharmacist/organisations/${organisationId}/features`);
  return response.data;
}

async function assignPharmacyToOrder(orderId, pharmacyId, deliveryOption, deliveryAddress) {
  const response = await coreApi.put(`/orders/support/${orderId}`, {
    pharmacy_id: pharmacyId,
    delivery_option: deliveryOption === 'delivery' ? 'postal_delivery' : deliveryOption,
    ...(deliveryAddress ? { delivery_address: deliveryAddress } : {}),
  });

  return response.data.data;
}

const coreAPI = {
  getCategories,
  getCategoryGroups,
  updateCategory,
  syncCategories,
  getFeatureFlags,
  getOrganisationFeatures,
  assignPharmacyToOrder,
};

export default coreAPI;
